import { Card } from '@mui/material';
import { Column, Row } from 'Components/Grid';
import { ContainerIcon } from '../styles';
import { ReactComponent as SecurityIcon } from './../../../../assets/security.svg';
import { useTranslation } from 'react-i18next';

export const CardTagGtm = ({ setShowCopyCode, setShowGtm, showGtm }) => {
  const { t } = useTranslation(['cookies']);
  return (
    <Card
      sx={{
        padding: '16px',
        marginBlockStart: '16px',
        backgroundColor: '#fffeFe',
        boxShadow: 'none',
        border: '1px solid #ccc',
      }}
    >
      <Row>
        <Column xs={9}>
          <span style={{ fontSize: '20px', fontWeight: '500' }}>{t('cookies:show.gtm.title')}</span>
          <br />
          <span style={{ fontSize: '16px', fontWeight: '400', color: '#34d399' }}>{t('cookies:show.gtm.recommended')}</span>
        </Column>
        <Column style={{ display: 'flex', justifyContent: 'end' }}>
          <ContainerIcon
            onClick={() => {
              setShowCopyCode(false);
              setShowGtm(!showGtm);
            }}
            active={showGtm}
          >
            <SecurityIcon width="44px" height="44px" style={{ padding: '8px' }} />
          </ContainerIcon>
        </Column>
      </Row>
      <Row>
        <Column xs={12}>
          <p style={{ marginBottom: '2.5rem' }}>
            {t('cookies:show.gtm.description')}
          </p>
        </Column>
      </Row>
    </Card>
  );
};
